import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import BrandMark from './BrandMark';
import PlayCta from './PlayCta';
import { hasGooglePlayUrl } from '../config/site';

const LINKS = [
  { href: '#kaip-veikia', label: 'Kaip veikia' },
  { href: '#galimybes', label: 'Galimybės' },
  { href: '#tevams', label: 'Tėvams' },
  { href: '#duk', label: 'DUK' },
  { href: '#kontaktai', label: 'Kontaktai' },
];

export function SiteHeader() {
  const [open, setOpen] = useState(false);

  const close = () => setOpen(false);

  return (
    <header className="site-header">
      <div className="site-header-inner">
        <a className="brand" href="#pradzia" onClick={close}>
          <BrandMark size={36} />
          <span>IšgerkVaistus</span>
        </a>

        <button
          type="button"
          className="nav-toggle"
          aria-expanded={open}
          aria-controls="site-nav"
          onClick={() => setOpen((value) => !value)}
        >
          {open ? 'Uždaryti' : 'Meniu'}
        </button>

        <nav id="site-nav" className={open ? 'site-nav is-open' : 'site-nav'}>
          {LINKS.map((link) => (
            <a key={link.href} href={link.href} onClick={close}>
              {link.label}
            </a>
          ))}
          {hasGooglePlayUrl() ? (
            <PlayCta className="play-cta-nav" label="Atsisiųsti" />
          ) : (
            <a className="play-cta play-cta-nav play-cta-link" href="#atsisiusti" onClick={close}>
              Atsisiųsti
            </a>
          )}
        </nav>
      </div>
    </header>
  );
}

export function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer" id="kontaktai">
      <div className="site-footer-inner">
        <div className="footer-brand">
          <BrandMark size={40} />
          <div>
            <strong>IšgerkVaistus</strong>
            <p>Paprasta lietuviška vaistų priminimų programėlė.</p>
          </div>
        </div>
        <div className="footer-links">
          <a href="mailto:sarunashelse@gmail.com">sarunashelse@gmail.com</a>
          <Link to="/privacy">Privatumo politika</Link>
          <Link to="/terms">Naudojimo sąlygos</Link>
          <Link to="/delete-account">Ištrinti paskyrą</Link>
          <a
            href="https://www.facebook.com/isgerkvaistus/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Facebook
          </a>
        </div>
        <p className="footer-copy">© {year} IšgerkVaistus</p>
      </div>
    </footer>
  );
}
